import { Reference } from "@apollo/client";

import useMutationWithValidation from "@hooks/useMutationWithValidation";
import {
  FileResourceDestroyDocument,
  FileResourceDestroyMutation,
  FileResourceDestroyMutationVariables,
  GetJourneyWithPlanQuery
} from "@typing/Generated";

const useDestroyFileResource = (journey: GetJourneyWithPlanQuery["journey"]) => {
  const [mutation] = useMutationWithValidation<FileResourceDestroyMutation, FileResourceDestroyMutationVariables>(
    FileResourceDestroyDocument,
    "fileResource",
    {
      update: (store, { data }) => {
        if (data?.fileResourceDestroy?.id) {
          const fileResourceBeingDeleted = journey.fileResources.find(
            resource => resource.id === data.fileResourceDestroy?.id
          );

          store.modify({
            fields: {
              fileResources(cachedRefs: readonly Reference[], { readField }) {
                return cachedRefs.filter(ref => data.fileResourceDestroy?.id !== readField("id", ref));
              }
            },
            id: store.identify({ ...journey })
          });

          if (fileResourceBeingDeleted?.folder) {
            store.modify({
              fields: {
                fileResources(cachedRefs: readonly Reference[], { readField }) {
                  return cachedRefs.filter(ref => data.fileResourceDestroy?.id !== readField("id", ref));
                }
              },
              id: store.identify({ __typename: "Folder", id: fileResourceBeingDeleted.folder.id })
            });
          }

          if (fileResourceBeingDeleted?.resource?.__typename === "LegalDocument") {
            store.modify({
              fields: {
                fileResources(cachedRefs: readonly Reference[], { readField }) {
                  return cachedRefs.filter(ref => data.fileResourceDestroy?.id !== readField("id", ref));
                }
              },
              id: store.identify({ __typename: "LegalDocument", id: fileResourceBeingDeleted.resource.id })
            });
          }
          if (fileResourceBeingDeleted?.worksheet?.id) {
            store.modify({
              fields: {
                fileResource() {
                  return null;
                }
              },
              id: store.identify({ __typename: "Worksheet", id: fileResourceBeingDeleted.worksheet.id })
            });
          }

          if (fileResourceBeingDeleted?.resource?.__typename === "Message") {
            store.modify({
              fields: {
                fileResources(cachedRefs: readonly Reference[], { readField }) {
                  return cachedRefs.filter(ref => data.fileResourceDestroy?.id !== readField("id", ref));
                }
              },
              id: store.identify({ __typename: "Message", id: fileResourceBeingDeleted.resource.id })
            });
          }
        }
      }
    }
  );
  return mutation;
};

export default useDestroyFileResource;
